import React, { useEffect } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

interface AdminGuardProps {
  children: React.ReactNode;
}

const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
  const { profile, isInitialized, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isInitialized && (!user || !profile || (profile.role !== 'admin' && profile.role !== 'super_admin'))) {
      console.log('AdminGuard: Access denied. User:', user, 'Profile:', profile);
      navigate('/login', { state: { from: location.pathname } });
    }
  }, [isInitialized, user, profile, navigate, location]);

  if (!isInitialized || !profile) {
    console.log('AdminGuard: Loading authentication data...');
    return (
      <div className="flex items-center justify-center h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  if (profile.role === 'admin' || profile.role === 'super_admin') {
    return <>{children}</>;
  }

  // This part should ideally not be reached due to the useEffect redirect,
  // but it serves as a fallback.
  return null;
};

export default AdminGuard;
